import React from 'react';

import FormDialog from 'scenes/Dialog/components/FormDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import SendMessageForm from 'scenes/Form/components/SendMessageForm';

import { MESSAGE_FOLDER } from 'constants/message-types';
import { InboxActions } from 'helpers/actions/inbox';

export const action = {
  inbox: {
    markAsRead: (api, { message, isOpen }, { grid }) => {
      const action = new InboxActions(api);
      action.markAsRead(api, { message, isOpen }, { grid });
    },

    remove: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.remove(api, { message }, { grid });
    },

    restore: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.restore(api, { message }, { grid });
    },

    removePermanently: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.removePermanently(api, { message }, { grid });
    },

    reply: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.reply(api, message, { grid });
    },

    forward: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.forward(api, message, { grid });
    },

    resumeAccept: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.resumeAccept(api, { message }, { grid });
    },

    resumeReject: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.resumeReject(api, { message }, { grid });
    },

    connectAccept: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.connectAccept(api, { message }, { grid });
    },

    connectReject: (api, { message }, { grid }) => {
      const action = new InboxActions();
      action.connectReject(api, { message }, { grid });
    },

    createMessage: grid => {
      FormDialog({
        title: 'Compose a Message',
        modeless: false,
        compact: true,
        popupStyles: { padding: '0', maxWidth: '800px' },
        popupInnerStyles: { padding: '0 30px' },
        params: { hasRecipientsSelection: true },
        form: (actions, params) => (
          <SendMessageForm actions={actions} params={params} />
        ),
      }).then(
        () =>
          grid.data.params.folder === MESSAGE_FOLDER.SENT
            ? grid.actions.fetch()
            : null,
        response => ResponseErrorDialog({ response })
      );
    },
  },
};
